/* eslint-disable no-console */
import { AbstractLogger } from './AbstractLogger';
import type { LogContext, Team } from '../types';

export class ConsoleLogger extends AbstractLogger {
  private prefix = `%cSDK`;

  public getPrefix() {
    return this.prefix;
  }

  private context: LogContext;

  public constructor(context: LogContext) {
    super();

    this.context = context;
  }

  public refreshContext(context: LogContext): void {
    this.context = context;
  }

  public log(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void {
    console.log(
      `${this.getPrefix()}/[${teams}]: ${message}`,
      '',
      ...optionalParams,
      this.context,
    );
  }

  public info(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void {
    console.info(
      `${this.getPrefix()}/[${teams}]: ${message}`,
      'color: grey;',
      ...optionalParams,
      this.context,
    );
  }

  public error(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void {
    console.error(
      `${this.getPrefix()}/[${teams}]: ${message}`,
      'color: red;',
      ...optionalParams,
      this.context,
    );
  }

  public success(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void {
    console.log(
      `${this.getPrefix()}/[${teams}]: ${message}`,
      'color: green;',
      ...optionalParams,
      this.context,
    );
  }
}
